import { IRequestCommand } from '../../authentication/connection/iRequestCommand';
import { ErrorDetails, TravelFareResponseDto } from '../../authentication/connection/interfaces/apiInterfaces';
import { CommandRequestType } from '../../authentication/connection/commandRequestType';
import { ICommandResponse } from '../../authentication/connection/iCommandResponse';
import { ICommandParameters } from '../../authentication/connection/iCommandParameters';
import { IPagination } from '../../authentication/connection/interfaces/pagination';

export class GetTravelFareByCarrierCommand extends IRequestCommand<IGridTravelFareResponse,
  ErrorDetails,
  IGetTravelFareByCarrierCommandParameters> {
  override _commandType: CommandRequestType = CommandRequestType.GET;

  override setParameters(params: IGetTravelFareByCarrierCommandParameters) {
    this.urlSections.push('carriers');
    this.urlSections.push('rate');
    this.urlSections.push(`${params.carrierUserId}`);
    this.composeUrl();
  }
}

export interface IGetTravelFareByCarrierCommandParameters
  extends IPagination,
    ICommandParameters {
  carrierUserId: number;
  name: string;
}

export interface IGridTravelFareResponse
  extends TravelFareResponseDto,
    ICommandResponse {
}
